import { useCallback, useEffect, useState } from "react";

const useMicrophonePermissions = () => {
  const [hasMicrophoneAccess, setHasMicrophoneAccess] = useState(null);
  const [isRequestingMicrophoneAccess, setIsRequestingMicrophoneAccess] = useState(false);

  useEffect(() => {
    let permissionStatus;

    const checkMicrophonePermissions = async () => {
      if (!navigator.permissions?.query) {
        setHasMicrophoneAccess(false);
        return;
      }

      try {
        permissionStatus = await navigator.permissions.query({ name: "microphone" });
        setHasMicrophoneAccess(permissionStatus.state === "granted");
        permissionStatus.onchange = () => {
          setHasMicrophoneAccess(permissionStatus.state === "granted");
        };
      } catch (err) {
        setHasMicrophoneAccess(false);
      }
    };

    checkMicrophonePermissions();

    return () => {
      if (permissionStatus) {
        permissionStatus.onchange = null;
      }
    };
  }, []);

  const requestMicrophoneAccess = useCallback(async () => {
    if (!navigator.mediaDevices?.getUserMedia) {
      setHasMicrophoneAccess(false);
      return false;
    }

    setIsRequestingMicrophoneAccess(true);

    try {
      const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
      stream.getTracks().forEach((track) => track.stop());
      setHasMicrophoneAccess(true);
      return true;
    } catch (err) {
      setHasMicrophoneAccess(false);
      return false;
    } finally {
      setIsRequestingMicrophoneAccess(false);
    }
  }, []);

  return {
    hasMicrophoneAccess,
    isRequestingMicrophoneAccess,
    requestMicrophoneAccess,
  };
};

export default useMicrophonePermissions;
